module.exports = __webpack_public_path__ + "static/media/albumOne.2c0289b9.jfif";